import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import { useNavigate } from "react-router-dom";
import { REDIRECT_PATH } from "../../../../Routes";
import ProductTagMasterContext from "../../../../context/ProductTagMasterContext/ProductTagMasterContext";
import {
  Delete_Product_Tag_Master,
  Enable_Disable_Product_Tag_Master,
  Get_Details_Product_Tag_Master,
} from "../../../../Apis/productTagMasterApi/ProductTagMasterApi";

const ProductTagMasterDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(ProductTagMasterContext);
  const { isLoading, data, refetch } = props;
  const history = useNavigate();

  /**
   * get product tag master Details
   */
  const {
    mutate: productTagMasterDetails,
    isLoading: isLoadingProductTagMasterDetails,
  } = useMutation((tagId) =>
    Get_Details_Product_Tag_Master(tagId, history, setFormData)
  );

  const GetProductTagMaster = (tagId) => {
    productTagMasterDetails(tagId);
    setId(tagId);
    setIsEdit(false);
  };

  /**
   * delete product tag master
   */
  const { mutate: productTagMasterDelete, isLoading: isLoadingDelete } =
    useMutation((tagId) => Delete_Product_Tag_Master(tagId, refetch));

  const DeleteProductTagMaster = async (tagId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      productTagMasterDelete(tagId);
    }
  };

  /**
   * enable / disable Product Tag Master
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Product_Tag_Master(formData, refetch)
  );

  const handleProductTagMasterStatusChange = (tagId, status) => {
    let formDate = {
      tagId: tagId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.tagId === tagId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const handleOpenandClosePopup = () => {
    history(`${REDIRECT_PATH.PRODUCTS_TAG}/add`);
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 250,
      field: "tagName",
      headerName: "Tag Name",
      renderCell: (params) => (params.row.tagName ? params.row.tagName : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "tagColor",
      headerName: "Tag Color",
      renderCell: (params) =>
        params.row.tagColor ? (
          <div
            style={{
              background: "#" + params.row.tagColor.replace("#", ""),
              height: "43px",
              width: "43px",
            }}
          ></div>
        ) : (
          "--"
        ),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleProductTagMasterStatusChange(
                params.row.tagId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => GetProductTagMaster(params.row.tagId)}
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => DeleteProductTagMaster(params.row.tagId)}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingProductTagMasterDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.tagId}
        addButton={true}
      />
    </Fragment>
  );
};

export default ProductTagMasterDataTabelContainer;
